import $ from 'jquery';
import 'slick-carousel';
import 'bootstrap';
import 'jquery-mask-plugin';
import Swal from 'sweetalert2';
import 'select2';

Dropzone.autoDiscover = false;
import 'dropzone';

// Utils
import match from './utils/match';
import { initReact } from './utils/initReact';

// routes
import showRegistrationForm from './routes/register/showRegistrationForm';
import appAccessCode from './routes/app/accessCode';
import { showLoginForm } from './routes/login/showLoginForm';
import { challengesIndex } from './routes/challenges/index';
import { challengesSearch } from './routes/challenges/search';
import { challengesCreate } from './routes/challenges/create';
import { challengesEdit } from './routes/challenges/edit';
import { subscribesShow } from './routes/subscribes/show';
import { challengesShow } from './routes/challenges/show';
import { challengesMine } from './routes/challenges/mine';
import { presencesIndex } from './routes/presences';
import { presencesGallery } from './routes/presences/gallery';
import { appIndex } from './routes/app';
import { profilesCover } from './routes/profiles/cover';
import { profilesPersonal } from './routes/profiles/personal';
import { profilesState } from './routes/profiles/state';
import { profilesRede } from './routes/profiles/rede';
import { profilesContact } from './routes/profiles/contact';
import { profilesPassword } from './routes/profiles/password';
import { profilesTerms } from './routes/profiles/terms';

// React
import Comments from './react/components/comments';

var APP = {
  vars: {
    selectState: $('.js-state-filter'),
    selectCity: $('.js-cities'),
    selectVp: $('#js-vicepresident'),
    selectSuper: $('.js-superintendent'),
    selectRegional: $('.js-regional'),
    selectUnity: $('#js-unities'),
    selectStore: $('#js-store'),
    selectFuncional: $('#js-funcional'),
    selectHabilities: $('#js-habilities'),
    gtmCategory: 'voluntariado-icea',
  },
  common: {
    init: () => {
      let $modalTrigger = document.getElementById('modal-trigger');

      if ($modalTrigger) {
        const title = $modalTrigger.getAttribute('data-title'),
          type = $modalTrigger.getAttribute('data-type'),
          text = $modalTrigger.getAttribute('data-text');

        Swal.fire({ title: `${title ? title : ''}`, text: `${text ? text : ''}`, icon: `${type ? type : ''}` });
      }

      if (typeof localStorage.policyCookies == 'undefined' || localStorage.policyCookies == '0') {
        localStorage.policyCookies = '0';
        document.body.classList.add('show-policy');
      } else {
        let expire = new Date(localStorage.policyCookiesExpire),
          today = new Date();

        if (today >= expire) {
          localStorage.policyCookies = 0;
          document.body.classList.add('show-policy');
        }
      }

      document.querySelector('.js-btn-cookies').addEventListener('click', e => {
        e.preventDefault();
        let date = new Date(new Date().setDate(new Date().getDate() + 30));
        localStorage.policyCookies = '1';
        localStorage.policyCookiesExpire = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        document.body.classList.remove('show-policy');
      });

      // Email Protective SPAM Solution
      const $mailContainer = document.querySelectorAll('[data-mail-creator]');

      if ($mailContainer.length) {
        $mailContainer.forEach(el => {
          let $mail = document.createElement('a');
          let arrMail = el.getAttribute('data-mail-creator').split(',');

          if (arrMail.length == 3) {
            let label =
              arrMail[0].replace(/\s/g, '') + '@' + arrMail[1].replace(/\s/g, '') + arrMail[2].replace(/\s/g, '');
            $mail.setAttribute('href', 'ma' + 'il' + 'to:' + label);
            $mail.textContent = label;
            el.appendChild($mail);
          }
        });
      }

      $('.js-gtm').on('click', function () {
        var title = $(this).attr('data-title');
        var action = $(this).attr('data-action');

        dataLayer = dataLayer || [];
        dataLayer.push({
          event: 'interaction',
          target: APP.vars.gtmCategory,
          action: action,
          'target-properties': title,
        });
      });

      $('.js-gtm-input').on('blur', function () {
        if (this.value.length > 0) {
          var title = $(this).attr('data-title');
          var action = $(this).attr('data-action');

          dataLayer = dataLayer || [];
          dataLayer.push({
            event: 'interaction',
            target: APP.vars.gtmCategory,
            action: action,
            'target-properties': title,
          });
        }
      });

      //Toggle Menu
      document.querySelector('.js-toggle-menu').addEventListener('click', e => {
        e.preventDefault();
        document.body.classList.toggle('nav-active');
      });

      $(document).on('click', '[data-modal-close]', function () {
        $(this).closest('.c-modal').removeClass('is-active');
        $('#modal-form').remove();
      });

      $('.js-modal-warning-logged').on('click', function (e) {
        e.preventDefault();
        Swal.fire({
          html:
            '<h3 class="o-ttl">' +
            $(this).attr('data-title') +
            '</h3>' +
            '<p>Você precisa realizar o seu login na plataforma para visualizar essas informações.</p>',
          padding: '25px 15px',
          position: 'top',
          showConfirmButton: false,
          showClass: {
            popup: 'c-new-swal--popup',
          },
          customClass: 'c-new-swal',
        });
      });

      $(document).on('click', '.js-delete', function (e) {
        e.preventDefault();
        let data_id = $(this).attr('data-id');

        Swal.fire({
          title: 'Excluir registro?',
          text: 'Tem certeza que deseja remover este registro?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#9C63FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, excluir registro!',
          cancelButtonText: 'Não excluir',
        }).then(result => {
          if (result.value) {
            var token = $('meta[name="csrf-token"]').attr('content');

            $.ajax({
              headers: {
                'X-CSRF-TOKEN': token,
              },
              url: $(this).attr('data-url'),
              method: 'DELETE',
              success: function (data) {
                Swal.fire(data.title, data.message, data.type);

                if (data.type == 'success') {
                  var row = document.getElementById(data_id);
                  row.parentNode.removeChild(row);
                }

                if (data.count) {
                  $('.js-counter').html(data.count);
                }
              },
            });
          }
        });
      });

      $(document).on('click', '.js-delete-custom', function (e) {
        e.preventDefault();
        let data_id = $(this).attr('data-id');
        let data_title = $(this).attr('data-message-title');
        let data_content = $(this).attr('data-message-content');

        Swal.fire({
          title: data_title,
          text: data_content,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#9C63FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, excluir!',
          cancelButtonText: 'Não excluir',
        }).then(result => {
          if (result.value) {
            var token = $('meta[name="csrf-token"]').attr('content');

            $.ajax({
              headers: {
                'X-CSRF-TOKEN': token,
              },
              url: $(this).attr('data-url'),
              method: 'DELETE',
              success: function (data) {
                Swal.fire(data.title, data.message, data.type);

                if (data.type == 'success') {
                  var row = document.getElementById(data_id);
                  row.parentNode.removeChild(row);

                  if (data.count) {
                    $('.js-counter').html(data.count);
                  }
                }
              },
            });
          }
        });
      });

      (function ($) {
        $.fn.inputFilter = function (inputFilter) {
          return this.on('input keydown keyup mousedown mouseup select contextmenu drop', function () {
            if (inputFilter(this.value)) {
              this.oldValue = this.value;
              this.oldSelectionStart = this.selectionStart;
              this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty('oldValue')) {
              this.value = this.oldValue;
              this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
              this.value = '';
            }
          });
        };
      })(jQuery);

      $('.js-number').inputFilter(function (value) {
        return /^\d*$/.test(value);
      });

      $('.file-input').change(function () {
        $('#label_' + this.name).text(this.files[0].name);
      });

      APP.vars.selectSuper.on('change', function (e) {
        e.preventDefault();

        var post = {};

        APP.vars.selectRegional.empty();
        APP.vars.selectRegional.append($('<option></option>').attr('value', '').text('Carregando...'));

        post.id = APP.vars.selectSuper.val();
        post._token = $('meta[name="csrf-token"]').attr('content');

        var url = '/busca-regionais/' + post.id;

        $.ajax({
          type: 'GET',
          url: url,
          data: post,
          cache: false,
          dataType: 'json',
          success: function (data) {
            if (data) {
              APP.vars.selectRegional.empty();

              APP.vars.selectRegional.append($('<option></option>').attr('value', '0').text('Selecione sua regional'));
              $.each(data, function (index, element) {
                APP.vars.selectRegional.append($('<option></option>').attr('value', index).text(element));
              });
            }
          },
        });
      });

      const $customCheck = $('[data-custom-check]');

      $customCheck.on('click', function (e) {
        const $check = $(this).find('input[type="checkbox"]');

        let $status = 0;

        if ($($check).is(':checked')) {
          $check.prop('checked', false);
        } else {
          $check.prop('checked', true);
          $status = 1;
        }

        let url = $(this).attr('data-url');
        var post = {};
        post.receive_notifications = $status;
        post._token = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
          type: 'POST',
          url: url,
          data: post,
          cache: false,
          dataType: 'json',
          success: function (data) {
            if (data.success) {
              Swal.fire(data.title, data.message, data.type);
            }
          },
        });
      });
    },
  },

  app: {
    index: () => {
      appIndex();
    },

    accessCode: () => {
      appAccessCode.init();
    },
  },

  login: {
    showLoginForm: () => {
      showLoginForm();
    },
  },

  register: {
    showRegistrationForm: () => {
      showRegistrationForm.init();
    },
  },

  profiles: {
    personal: () => {
      profilesPersonal();
    },

    cover: () => {
      profilesCover();
    },

    state: () => {
      profilesState();
    },

    rede: () => {
      profilesRede();
    },

    terms: () => {
      profilesTerms();
    },

    password: () => {
      profilesPassword();
    },

    contact: () => {
      profilesContact();
    },
  },
  challenges: {
    index: () => {
      challengesIndex();
    },

    search: () => {
      challengesSearch();
    },

    create: () => {
      challengesCreate();
    },

    edit: () => {
      challengesEdit();
    },

    show: () => {
      challengesShow();
      initReact(document.getElementById('comments'), Comments);
    },

    mine: () => {
      challengesMine();
    },

    gallery() {
      const $imgItem = document.querySelectorAll('[data-gallery-item]'),
        $galleryModal = document.querySelector('[data-gallery-modal]'),
        $bgEffect = document.querySelector('[data-bg-effect]'),
        $closeModal = document.querySelector('[data-close-modal]'),
        $prevArrow = document.querySelector('[data-modal-prev]'),
        $nextArrow = document.querySelector('[data-modal-next]');

      $prevArrow.addEventListener('click', () => {
        let $current = document.querySelector('.c-gallery__item.current'),
          $prevSibling = $current.previousElementSibling,
          type = $prevSibling.getAttribute('data-type'),
          mime = $prevSibling.getAttribute('data-mime'),
          url = $prevSibling.getAttribute('data-url'),
          id = $prevSibling.getAttribute('data-id');

        $galleryModal.querySelector('img, video').remove();

        if (id == 1) {
          $prevArrow.style.opacity = '0';
        } else {
          $prevArrow.style.opacity = '1';
          $nextArrow.style.opacity = '1';
        }

        if (type == 'image') {
          let $img = document.createElement('img');
          $img.setAttribute('src', url);
          $img.setAttribute('class', 'c-gallery-modal__img');
          $img.setAttribute('data-id', id);

          $galleryModal.appendChild($img);
        } else {
          let $video = document.createElement('video');
          $video.setAttribute('class', 'c-gallery-modal__video');
          $video.setAttribute('data-id', id);
          $video.controls = true;
          $video.autoplay = true;

          let $source = document.createElement('source');
          $source.type = mime;
          $source.src = url;
          $video.appendChild($source);

          $galleryModal.appendChild($video);
        }

        $current.classList.remove('current');
        $prevSibling.classList.add('current');
      });

      $nextArrow.addEventListener('click', () => {
        let $current = document.querySelector('.c-gallery__item.current'),
          $nextSibling = $current.nextElementSibling,
          type = $nextSibling.getAttribute('data-type'),
          mime = $nextSibling.getAttribute('data-mime'),
          url = $nextSibling.getAttribute('data-url'),
          id = $nextSibling.getAttribute('data-id');

        $galleryModal.querySelector('img, video').remove();

        if (id == $imgItem.length) {
          $nextArrow.style.opacity = '0';
        } else {
          $prevArrow.style.opacity = '1';
          $nextArrow.style.opacity = '1';
        }

        if (type == 'image') {
          let $img = document.createElement('img');
          $img.setAttribute('src', url);
          $img.setAttribute('class', 'c-gallery-modal__img');
          $img.setAttribute('data-id', id);

          $galleryModal.appendChild($img);
        } else {
          let $video = document.createElement('video');
          $video.setAttribute('class', 'c-gallery-modal__video');
          $video.setAttribute('data-id', id);
          $video.controls = true;
          $video.autoplay = true;

          let $source = document.createElement('source');
          $source.type = mime;
          $source.src = url;
          $video.appendChild($source);

          $galleryModal.appendChild($video);
        }

        $current.classList.remove('current');
        $nextSibling.classList.add('current');
      });

      if ($imgItem.length) {
        $imgItem.forEach(el => {
          el.addEventListener('click', e => {
            let type = e.currentTarget.getAttribute('data-type'),
              mime = e.currentTarget.getAttribute('data-mime'),
              url = e.currentTarget.getAttribute('data-url'),
              id = e.currentTarget.getAttribute('data-id');

            el.classList.add('current');

            if (id == 1) {
              $prevArrow.style.opacity = '0';
            } else if (id == $imgItem.length) {
              $nextArrow.style.opacity = '0';
            } else {
              $prevArrow.style.opacity = '1';
              $nextArrow.style.opacity = '1';
            }

            $bgEffect.classList.add('active');
            $galleryModal.classList.add('active');

            if (type == 'image') {
              let $img = document.createElement('img');
              $img.setAttribute('src', url);
              $img.setAttribute('class', 'c-gallery-modal__img');
              $img.setAttribute('data-id', id);

              $galleryModal.appendChild($img);
            } else {
              let $video = document.createElement('video');
              $video.setAttribute('class', 'c-gallery-modal__video');
              $video.setAttribute('data-id', id);
              $video.controls = true;
              $video.autoplay = true;

              let $source = document.createElement('source');
              $source.type = mime;
              $source.src = url;
              $video.appendChild($source);

              $galleryModal.appendChild($video);
            }
          });
        });

        $closeModal.addEventListener('click', () => {
          document.querySelector('.c-gallery__item.current').classList.remove('current');

          $bgEffect.classList.remove('active');
          $galleryModal.classList.remove('active');

          setTimeout(() => {
            $galleryModal.querySelector('img, video').remove();
          }, 500);
        });

        const $loadmore = document.querySelector('[data-load]');
        if ($loadmore) {
          $loadmore.addEventListener('click', () => {
            let count = 0;
            $imgItem.forEach(el => {
              if (el.classList.contains('c-gallery__item--hidden') && count < 4) {
                el.classList.remove('c-gallery__item--hidden');
                count++;
              }
            });

            let moreItems = false;
            $imgItem.forEach(el => {
              if (el.classList.contains('c-gallery__item--hidden')) {
                moreItems = true;
              }
            });

            if (!moreItems) {
              $loadmore.style.display = 'none';
            }
          });
        }
      }
    },

    materials() {
      const $search = document.getElementById('js-search'),
        $listContainer = document.getElementById('js-list-container'),
        $listContainerDump = $listContainer.querySelector('.c-materials-list'),
        $pagination = document.getElementById('js-pagination'),
        $filterType = document.getElementById('js-filter-type');

      $search.addEventListener('keyup', e => {
        filterRequest(e.target.value, $filterType.value.length > 0 ? $filterType.value : null);
      });

      $filterType.addEventListener('change', e => {
        filterRequest($search.value.length > 0 ? $search.value : null, e.target.value);
      });

      let delay;
      function filterRequest(therm = null, type = null) {
        clearTimeout(delay);
        delay = setTimeout(() => {
          if (therm || type) {
            $.ajax({
              url: '/acoes/materiais/filtro',
              type: 'POST',
              data: {
                _token: document.querySelector('[name="csrf-token"]').getAttribute('content'),
                _id: document.querySelector('[name="challenge_id"]').value,
                _therm: therm,
                _type: type,
              },
              success: function (data) {
                if (data.success) {
                  $listContainer.innerHTML = '';
                  $($listContainer).append($(data.materials));

                  if ($pagination) {
                    $pagination.classList.add('is-hidden');
                  }
                } else {
                  console.log('Erro!');
                }
              },
            });
          } else {
            $listContainer.innerHTML = '';
            $listContainer.append($listContainerDump);

            if ($pagination) {
              $pagination.classList.remove('is-hidden');
            }
          }
        }, 300);
      }
    },
  },
  presences: {
    init: () => {},

    index: () => {
      presencesIndex();
    },

    activities: () => {
      $('.custom-control-input').on('change', function (e) {
        let type = $("input[name='type']:checked").val();

        if (this.value == 1) {
          $('#' + $(this).attr('data-id')).removeClass('u-display--none');
        } else {
          $('#' + $(this).attr('data-id')).addClass('u-display--none');
          $('#' + $(this).attr('data-id'))
            .find('input:text')
            .val('');
        }
      });
    },

    participants: () => {
      Dropzone.autoDiscover = false;

      var token = $('meta[name="csrf-token"]').attr('content');

      Dropzone.options.myDropzone = {
        url: 'lista-de-presenca/upload-lista',
        paramName: 'presence_list',
        maxFilesize: 10,
        maxFiles: 50,
        acceptedFiles:
          'image/*,application/pdf,application/doc,application/docx,application/ppt,application/pptx,application/xls,application/xlsx',
        params: {
          _token: token,
        },
        addRemoveLinks: true,
        dictDefaultMessage: 'Selecione as imagens que deseja enviar',
        dictCancelUpload: 'Cancelar o envio',
        dictRemoveFile: 'Remover',
        dictMaxFilesExceeded: 'Você já adicionou uma foto',
        dictFileTooBig: 'Arquivo muito grande',
        dictInvalidFileType: 'Este arquivo não é uma imagem',
        init: function () {
          this.on('success', function (file, response) {
            $('.added_presence').append(
              '<input type="hidden" data-name="' + file.name + '" name="presence_list[]" value="' + response + '"/>'
            );
          });
          this.on('removedfile', function (file, response) {
            $("input[name='presence_list[]']").each(function () {
              if ($(this).attr('data-name') == file.name) {
                $(this).remove();
              }
            });
          });
        },
      };

      $('#myDropzone').dropzone();

      Dropzone.options.myDropzoneterms = {
        url: 'lista-de-presenca/upload-termos',
        paramName: 'terms',
        maxFilesize: 10,
        maxFiles: 50,
        acceptedFiles:
          'image/*,application/pdf,application/doc,application/docx,application/ppt,application/pptx,application/xls,application/xlsx',
        params: {
          _token: token,
        },
        addRemoveLinks: true,
        dictDefaultMessage: 'Selecione as imagens que deseja enviar',
        dictCancelUpload: 'Cancelar o envio',
        dictRemoveFile: 'Remover',
        dictMaxFilesExceeded: 'Você já adicionou uma foto',
        dictFileTooBig: 'Arquivo muito grande',
        dictInvalidFileType: 'Este arquivo não é uma imagem',
        init: function () {
          this.on('success', function (file, response) {
            $('.added_terms').append(
              '<input type="hidden" data-name="' + file.name + '" name="terms[]" value="' + response + '"/>'
            );
          });
          this.on('removedfile', function (file, response) {
            $("input[name='terms[]']").each(function () {
              if ($(this).attr('data-name') == file.name) {
                $(this).remove();
              }
            });
          });
        },
      };

      $('#myDropzoneterms').dropzone();

      Dropzone.options.myDropzoneimage = {
        url: 'lista-de-presenca/upload-imagem',
        paramName: 'images',
        maxFilesize: 10,
        maxFiles: 50,
        acceptedFiles:
          'image/*,application/pdf,application/doc,application/docx,application/ppt,application/pptx,application/xls,application/xlsx',
        params: {
          _token: token,
        },
        addRemoveLinks: true,
        dictDefaultMessage: 'Selecione as imagens que deseja enviar',
        dictCancelUpload: 'Cancelar o envio',
        dictRemoveFile: 'Remover',
        dictMaxFilesExceeded: 'Você já adicionou uma foto',
        dictFileTooBig: 'Arquivo muito grande',
        dictInvalidFileType: 'Este arquivo não é uma imagem',
        init: function () {
          this.on('success', function (file, response) {
            $('.added_images').append(
              '<input type="hidden" data-name="' + file.name + '" name="images[]" value="' + response + '"/>'
            );
          });
          this.on('removedfile', function (file, response) {
            $("input[name='images[]']").each(function () {
              if ($(this).attr('data-name') == file.name) {
                $(this).remove();
              }
            });
          });
        },
      };

      $('#myDropzoneimage').dropzone();
    },

    gallery: () => {
      presencesGallery();
    },

    savedreport: () => {
      $('.js-success').on('click', function () {
        Swal.fire({
          title: 'Obrigado!',
          text: 'Ação concluída!',
          icon: 'success',
        }).then(() => {
          window.location.href = '/minhas-acoes';
        });
      });
    },
  },
  faqs: {
    init: () => {
      $('.js-question').on('click', function (e) {
        e.preventDefault();

        if ($('#' + $(this).attr('data-id')).hasClass('c-faq__content-active')) {
          $('#' + $(this).attr('data-id')).removeClass('c-faq__content-active');
        } else {
          $('#' + $(this).attr('data-id')).addClass('c-faq__content-active');
        }
      });

      $('.o-input--faq').on('input', function () {
        var val = this.value.toLowerCase();

        $('.c-faq__content')
          .find('.js-question')
          .filter(function () {
            return $(this).data('title').toLowerCase().indexOf(val) > -1;
          })
          .show()
          .end()
          .filter(':visible')
          .filter(function () {
            return $(this).data('title').toLowerCase().indexOf(val) === -1;
          })
          .fadeOut();
      });
    },
  },
  forgotpassword: {
    init: () => {
      $('#form-recovery-email').on('submit', function (e) {
        e.preventDefault();

        var post = {};

        post.cpf = $('#cpf').val();
        post['g-recaptcha-response'] = $('[name="g-recaptcha-response"]').val();
        post._token = $('meta[name="csrf-token"]').attr('content');

        var url = $(this).attr('action');

        $.ajax({
          type: 'POST',
          url: url,
          data: post,
          dataType: 'json',
          success: function (data) {
            Swal.fire(data.title, data.message, data.type);
          },
        });
      });
    },
  },
  habilities: {
    index: () => {
      $('.js-see--more').on('click', function (e) {
        e.preventDefault();
        $('#' + $(this).attr('data-id')).removeClass('s-habilities--list-closed');
        $('#card-' + $(this).attr('data-id')).removeClass('s-habilities--card-closed');
        $(this).css('display', 'none');
      });
    },
  },
  resetpassword: {
    showResetForm: () => {
      let $pass = document.getElementById('password_user'),
        $confirmPass = document.getElementById('password_confirmation'),
        $danger = document.querySelector('[data-error]'),
        submit = false,
        regex = /^(?=.*[A-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(?=.*[0-9])(?=.*[a-z]).{8,}$/,
        $passInputs = document.querySelectorAll('#password_confirmation, #password_user'),
        $form = document.querySelector('.js-pass-rules');

      function complexPassword() {
        if (!regex.exec($pass.value)) {
          submit = false;
          return false;
        }
        return true;
      }

      function confirmation() {
        if ($pass.value != $confirmPass.value) {
          submit = false;
          return false;
        }

        return true;
      }

      function minLength() {
        if ($pass.value.length < 8) {
          submit = false;
          return false;
        } else {
          return true;
        }
      }

      function message(msg) {
        if ($danger) {
          if (msg) {
            $danger.innerHTML = msg;
            $danger.style.display = 'block';
          } else {
            $danger.innerHTML = '';
            $danger.style.display = 'none';
          }
        }
      }

      if ($passInputs.length) {
        $passInputs.forEach(item => {
          item.addEventListener('input', function () {
            message(false);

            if (!confirmation()) {
              message('Senhas diferentes.');
            } else if (!minLength()) {
              message('A senha precisa ter o mínimo de 8 caracteres.');
            } else if (!complexPassword()) {
              message('A senha deve conter letras maiúsculas, minúsculas, números e caracteres especiais.');
            } else {
              submit = true;
            }
          });
        });
      }

      if ($form.length) {
        $form.addEventListener('submit', function (e) {
          if (!submit) {
            e.preventDefault();
          }
        });
      }
    },
  },

  subscribes: {
    show: () => {
      subscribesShow();
    },
  },
};

document.addEventListener('DOMContentLoaded', match.init(APP));

$('.js-form-cpf').mask('999.999.999-99');
$('.js-form-cnpj').mask('99.999.999/9999-99');
$('.js-form-date').mask('99/99/9999');
$('.js-form-hour').mask('99:99');
$('.js-form-ddd').mask('(99)');
$('.js-form-phone').mask('(99) 99999.9999');
$('.js-form-phone-commercial').mask('(99) 9999.9999');
$('.js-form-zipcode').mask('99999-999');
$('.js-form-number').mask('99999999999');
